import React from "react";
import {Tag} from "primereact/tag";
import { TopupPartnerDto } from "../../../domain/dtos/topup-partner";
import { TawreedMenu } from "../../../../constants";
import { ObjectUtils } from "../../../../../helpers/object";
import { tawreedTranslationService } from "../../../../../common/translations";

export type TopupPartnerAutocompleteItemTemplateProps = {
    /**
     *
     */
    rowData: TopupPartnerDto;

    /**
     *
     */
    partnersMenu: TawreedMenu | undefined;
}

export const TopupPartnerAutocompleteItemTemplate: React.FC<TopupPartnerAutocompleteItemTemplateProps> = (props) => {

    return (
        <div className="">
            <div className="flex">
                <span className="mr-auto">{props.rowData.partnerName}</span>
                <Tag rounded severity={'success'}
                     style={{width: '5rem'}}
                     value={(props.rowData.partnerType && props.partnersMenu) ? ObjectUtils.fromMenu(props.rowData.partnerType, props.partnersMenu) : tawreedTranslationService.translate('lbl_partner_' + props.rowData.partnerType)}/>
            </div>
            <div style={{fontSize: '.75rem', color: 'var(--text-secondary-color)'}}>
                {`${tawreedTranslationService.translate("lbl_minimum_topup")} ${props.rowData.minimumTopUp} ${tawreedTranslationService.translate("lbl_unit")}`}
                <br/>
                {`${tawreedTranslationService.translate("lbl_maximum_topup")} ${props.rowData.maximumTopUp} ${tawreedTranslationService.translate("lbl_unit")}`}
                
            </div>
        </div>
    );
}
